import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse, HttpEvent } from "@angular/common/http";
 
import { Observable, throwError } from 'rxjs';
 
@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    constructor(  ) { }
    handleError(error: HttpErrorResponse){
        return throwError(error);
    }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
 
        //     req = req.clone({
        //         setHeaders: {
        //         //    'Authorization':  'Bearer ' + authToken,
        //            'Access-Control-Allow-Origin':'*',
        //            "Access-Control-Allow-Headers": "content-type, withcredentials, Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
        //            'content-type':'application/json'
        //        }
        //    });
           return next.handle(req) 

    }
}